import * as React from "react";
import styles from "./chat-footer.scss";
import { MdDeleteOutline } from "react-icons/md";

export const ChatFooter = ({
  clearChat,
  registerCase,
  canActOnDraft,
  className,
  textRegisterCase,
  textClearChat
}: {
  clearChat: () => void, 
  registerCase: () => void,
  canActOnDraft: boolean,
  className?: string,
  textRegisterCase: string,
  textClearChat: string
}) => (
  <div className={`${styles.chatFooter} ${className || ""}`}>
    <button
      className={`btn btn-call-to-action ${styles.btnRegisterCase}`}
      onClick={() => registerCase()}
      disabled={!canActOnDraft}
    >
      {textRegisterCase}
    </button>

    <button className={styles.clearChat} onClick={clearChat}>
      <MdDeleteOutline className={styles.clearChatIcon} />
      {textClearChat}
    </button>

  </div>
);
